import { Module } from "@nestjs/common";
import { ScheduleModule } from "@nestjs/schedule";
import { TypeOrmModule } from "@nestjs/typeorm";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { PVHOrdersEntity } from "./entities/pvh-orders.entity";
import { PVHController } from "./pvh.controller";
import { PVHService } from "./pvh.service";
import { PVHOrdersRepository } from "./repositories/pvh-orders.repo";
import { GapAddressService } from "../Entites@Shahi/gap-address/gap-address-service";
import { GapAddressRepository } from "../Entites@Shahi/gap-address/gap-address.repo";
import { GapAddressEntity } from "../Entites@Shahi/gap-address/gap-address-entity";
import { CkAddressService } from "../Entites@Shahi/ck-address/ck-address-service";
import { CkAddressRepository } from "../Entites@Shahi/ck-address/ck-address.repo";
import { CkAddressEntity } from "../Entites@Shahi/ck-address/ck-address-entity";
import { PvhOrdersChildRepository } from "./repositories/pvh-orders-child.repo";
import { PvhOrderschildEntity } from "./entities/pvh-orders-child.entity";
import { PvhPdfInfoEntity } from "./entities/pvh-pdf.entity";
import { PvhPdfRepo } from "./repositories/pvh-pdf.repo";
import { PvhCOLineEntity } from "./entities/pvh-co-line.entity";
import { PvhCOLineRepository } from "./repositories/pvh-co-line.repository";
import { TommySizeRepository } from "../Entites@Shahi/tommy-n-a-size/tomm-n-a-repo";
import { TommySizeEntity } from "../Entites@Shahi/tommy-n-a-size/tommy-n-a-entity";
import { TommySizeService } from "../Entites@Shahi/tommy-n-a-size/tommy-n-a-service";
import { TommyNaAddressEntity } from "../Entites@Shahi/tommy-north-address/tommy-na-address-entity";
import { TommyNaAddressRepository } from "../Entites@Shahi/tommy-north-address/tommy-na-address.repo";
import { TommyNaAddressService } from "../Entites@Shahi/tommy-north-address/tommy-na-address-service";
import { TommyNaColorEntity } from "../Entites@Shahi/tommy-n-a-color/tommy-n-acolor-entity";
import { TommyNaColorService } from "../Entites@Shahi/tommy-n-a-color/tommy-n-acolor-service";
import { TommyNaColorRepository } from "../Entites@Shahi/tommy-n-a-color/tomm-n-a-color-repo";
import { TommyErAddressService } from "../Entites@Shahi/tommy-europe-address/tommy-er-address-service";
import { TommyErAddressRepository } from "../Entites@Shahi/tommy-europe-address/tommy-er-address.repo";
import { TommyErAddressEntity } from "../Entites@Shahi/tommy-europe-address/tommy-er-address-entity";
import { SizeRepository } from "../Entites@Shahi/size/size-repo";
import { SizeService } from "../Entites@Shahi/size/size-service";
import { SizeEntity } from "../Entites@Shahi/size/size-entity";
import { ColorEntity } from "../Entites@Shahi/color/color-entity";
import { ColorRepository } from "../Entites@Shahi/color/color-repo";
import { ColorService } from "../Entites@Shahi/color/color-service";
import { AddressEntity } from "../Entites@Shahi/address/address-entity";
import { AddressService } from "../Entites@Shahi/address/address-service";
import { AddressRepository } from "../Entites@Shahi/address/address.repo";



@Module({
  imports: [
    ScheduleModule.forRoot(),
    TypeOrmModule.forFeature([
        PVHOrdersEntity,
        GapAddressEntity,
        CkAddressEntity,
        PvhOrderschildEntity,
        PvhPdfInfoEntity,
        PvhCOLineEntity,
        TommySizeEntity,
        TommyNaAddressEntity,
        TommyNaColorEntity,
        TommyErAddressEntity,
        SizeEntity,
        ColorEntity,
        AddressEntity

    ])],
  controllers: [PVHController],
  providers: [PVHService,ApplicationExceptionHandler,PVHOrdersRepository,GapAddressService,GapAddressRepository,CkAddressService,CkAddressRepository,PvhOrdersChildRepository,PvhPdfRepo,PvhCOLineRepository,TommySizeRepository,TommySizeService,TommyNaAddressRepository,TommyNaAddressService,TommyNaColorService,TommyNaColorRepository,TommyErAddressService,TommyErAddressRepository,SizeRepository,SizeService,ColorRepository,ColorService,AddressService,AddressRepository]
})
export class PVHModule { }